/**
 * File: useRemindersController.ts
 * Path: apps/admin/src/features/today/hooks/useRemindersController.ts
 * Description: Today's "Reminders to send": each reminder the server
 * prepared, and Liam's one tap on it. Sent: a WhatsApp is recorded (he
 * opens wa.me from the same tap), the 14-day email goes out from the
 * server with the invoice and statement, a call is noted. Dismissed: it
 * never comes back. Nothing reaches a client without his tap.
 */
import { useMemo } from "react";
import { useInvoiceSendingMutations } from "@/shared/hooks/useInvoiceSendingMutations";
import { reminderRow, type ReminderRow } from "../utils/remindersUtils";
import { useReminders } from "./useRemindersQueries";

export const useRemindersController = () => {
  const proposals = useReminders();
  const { run, pending } = useInvoiceSendingMutations();
  const rows = useMemo(() => proposals.map(reminderRow), [proposals]);
  const done = (row: ReminderRow, outcome: "sent" | "dismissed") =>
    run({ action: "reminderDone", invoiceNumber: row.invoiceNumber, kind: row.kind, outcome });
  return {
    rows,
    pending,
    send: (row: ReminderRow) => {
      if (row.blocker) return;
      done(row, "sent");
    },
    dismiss: (row: ReminderRow) => done(row, "dismissed"),
  };
};
